const COMMENTS = [
  {
    name: '漫迷小王',
    avatar: '王',
    date: '3天前',
    content: '从大学开始用樱花漫画追更，现在已经工作三年了。下载离线功能简直是通勤救星，地铁上信号不好也能看。收藏夹整理得井井有条，找漫画特别方便，真心推荐给所有漫画爱好者！',
    likes: 128,
  },
  {
    name: '追番少女阿琳',
    avatar: '琳',
    date: '5天前',
    content: '日漫韩漫国漫一个App全搞定，再也不用切来切去了。追更提醒功能太贴心了，《咒术回战》每次更新第一时间就能看到。画质清晰流畅，阅读体验比之前用的好几个平台都好。',
    likes: 96,
  },
  {
    name: '二次元老司机',
    avatar: '老',
    date: '1周前',
    content: '用了快两年了，漫画资源真的很全。冷门老番也能搜到，分类索引特别实用，淘到了好几部宝藏漫画。离线下载速度很快，睡前下载几话第二天路上看，完美！希望平台越做越好。',
    likes: 75,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            读者评论
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            听听漫画爱好者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {COMMENTS.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-sm font-semibold text-secondary-700">{comment.avatar}</span>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950">{comment.name}</h3>
                  <span className="text-xs text-foreground-500">{comment.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}